<template>
  <div class="main-layout-wrapper">
    <!-- سایدبار در اینجا قرار می‌گیرد و فقط یک بار رندر می‌شود -->
    <Sidebar />
    
    <!-- محتوای صفحات اینجا لود می‌شود -->
    <div class="content-area">
      <router-view />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar/Sidebar.vue';

export default {
  name: 'MainLayout',
  components: {
    Sidebar
  }
}
</script>

<style scoped lang="scss">
.main-layout-wrapper {
  display: flex;
  width: 100%;
  min-height: 100vh;
  direction: rtl;
  background:rgb(12 57 123 / 18%);
}

.content-area {
 position: absolute;
    background: #ffffff;
    right: 18.1vw;
    left: 0.7vw;
    top: 4.8vw;
    border-radius: 10px;
    bottom: 0.7vw;
    box-shadow: 0 0.2vw 0.8vw rgba(0, 0, 0, 0);
    padding: 2vw;

}
</style>